<!--suppress JSAnnotator -->
<template>
  <div></div>
</template>

<script>
export default {
  name  : "PersonalProfileEdit",
  props : {
    items : {
      type : Object,
      default : () => ([]),
    }
  },
  data  : () => ( {
    checkEditStatus : false,
    dataUser : {}
  } ),
  created(){
    this.dataUser = this.items;
  },
  methods  : {

    checkEdit(status){
      this.checkEditStatus = status;
      event.preventDefault();
      setTimeout( () => {
        setPhoneMask($('.mask-phone'));
        setDateMask();
      }, 1000)
    },

    sendForm(){
      let form = event.target.closest("form");
      let formData = new FormData(form)
      formData.append("ajax","yes");
      formData.append("save","Отправить");
      event.preventDefault();
      fetch(formData.get('action'), {
        method: 'POST',
        body: formData
      }).then(
          response => {
            response.json().then(answer => {
              this.dataUser = answer;
              if(answer.NAME_HEADER)
                {
                  vmApp.$store.commit('setUserHeaderName', answer.NAME_HEADER);
                }
              if(answer && answer.ERRORS && answer.ERRORS.message){
                showHeaderMessage(answer.ERRORS.message, 'error');
              }
              if(answer && answer && answer.message){
                showHeaderMessage(answer.message, 'success');
              }
            });
          },
      );
      return false;
    },
    removeUser()
      {
        this.$refs.modalDeleteUser.open();
      },
    sendRemoveUser()
      {
        let el = this;
        let formData = new FormData()
        formData.append("ajax_command", "removeUser");
        formData.append("sessid", BX.bitrix_sessid());
        formData.append("z", "1");
        event.preventDefault();
        fetch("/local/php_interface/ajax/", {
          method: 'POST',
          body: formData
        }).then(
            response => {
              response.json().then(answer => {
                if (answer.success == true) {
                  el.$refs.modalDeleteUser.decline();
                  el.$refs.modalDeleteUserSuccess.open();
                  setTimeout(function(  )
                  {
                    window.location.href = "/";
                  }, 3000)
                }
              });
            },
        );
      }
  }
}
</script>